import {Component, inject, Input, OnInit} from '@angular/core';
import {SuperObjectModel} from "../../../core/definitions/super-object-model";
import {DateToolsService} from "../../../core/date-tools.service";

@Component({
    selector: 'app-collection-status-log',
    templateUrl: './collection-status-log.component.html',
    styleUrls: ['./collection-status-log.component.scss'],
    standalone: false
})
export class CollectionStatusLogComponent   implements OnInit {
  // Injections
  private readonly dateTools: DateToolsService = inject(DateToolsService);

  @Input() object: SuperObjectModel;

  logItems: any[] = [];
  displayedColumns = ['updated_at', 'updated_by', 'to_status', 'from_status'];

  ngOnInit(): void {
    const logData = this.object.collection_status_log || [];
    this.logItems = logData.map(item => {
      return {
        updated_at: this.dateTools.isoDateToString(item.updated_at),
        updated_by: item.updated_by_id_value,
        to_status: item.to_status_id_value,
        from_status: item.from_status_id_value
      }
    });
  }
}
